// Module
var code = "<h2 class=\"interiorSectionHeading\">View Loan Details </h2> <ul> <li> <strong>Check your total loan balance.</strong></li> <li> See the status of all your loans.</li> <li> View interest rates.</li> </ul> ";
// Exports
export default code;